import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths'
import { useTranslation } from 'react-i18next'

const routeTitles: { [key: string]: string } = {
  [AppRoutePaths.index]: 'home',
  [AppRoutePaths.auth.login]: 'login',
  [AppRoutePaths.auth.twofa]: 'two_factor_authentication',
  [AppRoutePaths.auth.forgot_password.index]: 'forgot_password',
  [AppRoutePaths.auth.reset_password]: 'reset_password',
  [AppRoutePaths.auth.register]: 'sign_up',
  [AppRoutePaths.auth.email_verification]: 'email_verification',
  [AppRoutePaths.privacy_statement.index]: 'privacy_statement',
  [AppRoutePaths.marketplace.index]: 'marketplace',
  [AppRoutePaths.termsAndConditions.index]: 'terms_and_conditions',
  [AppRoutePaths.payments.index]: 'payments',
  [AppRoutePaths.reimbursements.index]: 'reimbursements',
  [AppRoutePaths.notifications.index]: 'notifications',
  [AppRoutePaths.my_account.index]: 'my_account',
  [AppRoutePaths.assessments.index]: 'assessments',
  [AppRoutePaths.appeals.index]: 'appeals',
  [AppRoutePaths.appeals.new]: 'new_appeal',
  [AppRoutePaths.appeals.resolved.index]: 'resolved_appeals',
  [AppRoutePaths.family_application.index]: 'family_application',
  [AppRoutePaths.family_application.about]: 'about_family_application',
  [AppRoutePaths.family_application.identity_verification.index]:
    'identity_verification',
  [AppRoutePaths.family_application.residency_verification.index]:
    'residency_verification',
  [AppRoutePaths.family_application.student_details.index]: 'student_details',
  [AppRoutePaths.family_application.student_details.enter_details]:
    'student_details',
  [AppRoutePaths.family_application.student_details.scholarships]:
    'scholarship_participation',
  [AppRoutePaths.family_application.student_details.scholarship_warning]:
    'scholarship_wrning',
  [AppRoutePaths.family_application.student_details.lea]: 'local_education',
  [AppRoutePaths.family_application.student_details.capture_instructions]:
    'student_identity_verification',
  [AppRoutePaths.family_application.student_details.capture]:
    'upload_birth_certificate',
  [AppRoutePaths.family_application.student_details.photo_review]:
    'photo_review',
  [AppRoutePaths.family_application.student_details.document_submitted]:
    'document_submitted',
  [AppRoutePaths.family_application.student_details.success_verification]:
    'student_detail_completed',
  [AppRoutePaths.family_application.student_details.additional_student]:
    'additional_students',
  [AppRoutePaths.family_application.student_details.special_education.index]:
    'select_document_type',
  [AppRoutePaths.family_application.student_details.special_education
    .capture_instructions]: 'special_education_verification',
  [AppRoutePaths.family_application.student_details.special_education
    .document_capture]: 'proof_special_education',
  [AppRoutePaths.family_application.student_details.special_education
    .document_review]: 'photo_review',
  [AppRoutePaths.family_application.income_verification.index]:
    'income_verification',
  [AppRoutePaths.family_application.attestations.index]: 'attestations',
  [AppRoutePaths.family_application.review_application]: 'review_application',
  [AppRoutePaths.family_application.application_sent]: 'application_sent',
}

export function TitleManager() {
  const location = useLocation()
  const { t: translate } = useTranslation()

  useEffect(() => {
    const pathname = location.pathname
    let titleKey = routeTitles[pathname] || 'ace_access'

    // Handle dynamic routes
    if (pathname.startsWith(AppRoutePaths.appeals.id.split(':')[0])) {
      titleKey = 'appeal_details'
    }

    document.title = translate(titleKey)
  }, [location, translate])

  return null
}
